module.exports = __webpack_public_path__ + "static/media/goncalo_ferreira2.c2c87286.jpg";